import { Wire } from "@domain/project/floorplan/wiring/wire";
import { FloorplanItemTextKonva } from "@project/floorplanner/konva/floorplan-item-text-konva";
import { FloorplanWorkspaceKonvaAdapter } from "@project/floorplanner/konva/floorplan-workspace-konva.adapter";
import { LabelLayoutKonva } from "@project/floorplanner/konva/label-layout-konva";
import Konva from "konva";
import { Line } from "konva/lib/shapes/Line";
import { Rect } from "konva/lib/shapes/Rect";
import { Text } from "konva/lib/shapes/Text";
import Group = Konva.Group;

export class WireKonva {
  static readonly COLOR_CODE = "#556C7CCC";

  static init(wire: Wire): Group {
    const parentGroup = new Konva.Group();
    const minHeight = 8;

    const wireGroup = new Konva.Group({
      x: wire.x,
      y: wire.y,
      rotation: wire.rotation,
      width: wire.width,
      height: minHeight,
      type: wire.type,
      scalingLength: wire.scalingLength,
      draggable: false,
    });
    wireGroup.setAttr(FloorplanWorkspaceKonvaAdapter.OBJECT_KEY, wire);
    wireGroup.setAttr("minWidth", 50);
    wireGroup.setAttr("minHeight", minHeight);

    const rect = new Konva.Rect({
      height: minHeight,
      width: wire.width,
    });
    wireGroup.add(rect);

    const line = new Konva.Line({
      points: [0, 0, wire.width, 0],
      fill: this.COLOR_CODE,
      stroke: this.COLOR_CODE,
      y: rect.height() / 2,
    });
    wireGroup.add(line);

    const itemText = FloorplanItemTextKonva.init(wire);
    const text = FloorplanItemTextKonva.getText(itemText);
    this.scaleText(text, wireGroup);
    FloorplanItemTextKonva.updateBackground(itemText);
    wireGroup.add(itemText);

    parentGroup.add(wireGroup, itemText);
    this.setTextPosition(itemText, wireGroup);

    wireGroup.on("transformstart", () => {
      itemText.hide();
    });

    wireGroup.on("transform", () => {
      wireGroup.width(wireGroup.width() * wireGroup.scaleX());
      wireGroup.height(wireGroup.height() * wireGroup.scaleY());

      line.points([0, 0, rect.width(), 0]);
      line.y(rect.height() / 2);

      rect.width(wireGroup.width());
      rect.height(wireGroup.height());
      this.scaleText(text, wireGroup);
      FloorplanItemTextKonva.updateBackground(itemText);
      this.setTextPosition(itemText, wireGroup);

      wireGroup.scaleX(1);
      wireGroup.scaleY(1);
    });

    wireGroup.on("transformend", () => {
      wire.updateForm(wireGroup.width(), wireGroup.height(), wireGroup.rotation(), wireGroup.x(), wireGroup.y());
      this.setTextPosition(itemText, wireGroup);
      const labelHidden = itemText.getAttr("labelHidden") === true;
      if (!labelHidden) {
        itemText.show();
      }
    });

    wireGroup.on("dragmove", () => {
      this.setTextPosition(itemText, wireGroup);
    });

    return parentGroup;
  }

  static refreshLength(wire: Wire, parentGroup: Group) {
    const wireCableGroup = parentGroup.getChildren()[0] as Group;
    const rect = wireCableGroup.getChildren()[0] as Rect;
    const line = wireCableGroup.getChildren()[1] as Line;
    wireCableGroup.width(wire.width);
    rect.width(wire.width);
    line.points([0, 0, wire.width, 0]);
    this.refreshItemText(wire, parentGroup);
  }

  static refreshItemText(wire: Wire, group: Group) {
    const itemText = group.getChildren()[1] as Group;
    const wireGroup = group.getChildren()[0] as Konva.Group;

    FloorplanItemTextKonva.refreshText(wire, itemText);
    this.setTextPosition(itemText, wireGroup);
  }

  private static setTextPosition(itemText: Group, group: Group) {
    itemText.offsetY(0);
    itemText.offsetX(0);

    const item = group.getAttr(FloorplanWorkspaceKonvaAdapter.OBJECT_KEY);
    LabelLayoutKonva.placeLabelForItem(itemText, group, item);
  }

  private static scaleText(itemText: Text, pipelineGroup: Group) {
    itemText.fontSize(pipelineGroup.height() / 2);
  }
}
